module.exports = __webpack_public_path__ + "static/media/neutral.6f934935.png";